import { useQuery } from "@apollo/client";

import { AutocompleteModel } from "~/__generated__";
import useAutocompleteGetOptions from "~/modules/app/api/useAutocompleteGetOptions";

import { ProjectExportCreateForm_ResearchTypeGetAutocompleteOptionsDocument } from "../queries.generated";

export function useProjectExportCreate_GetData({ projectIds }: { projectIds: string[] }) {
    const { data } = useQuery(ProjectExportCreateForm_ResearchTypeGetAutocompleteOptionsDocument, {
        variables: { projectIds },
        skip: projectIds.length < 1,
    });

    const templatesAutocomplete = useAutocompleteGetOptions({
        model: AutocompleteModel.ProjectExportFileOptions,
    });

    return {
        researchTypes: data?.settingsResearchTypeGetAutocompleteOptions.data ?? [],
        templates: templatesAutocomplete.data ?? [],
    };
}
